import { BorderedContainer } from '../../../common/BorderedContainer';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import {
  convertToPresenceAbsence,
  formatDateTime,
} from '../../../common/converters';
import { TagList } from '../common/TagList';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 要請概要。 */
  requestSummary: IncidentDetailPatient['requestSummary'];
};

/** 要請概要のコンポーネント。 */
export const RequestSummary = ({ requestSummary }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="要請概要" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="発症日時"
            content={formatDateTime(requestSummary.onsetAt)}
          />
          <InfoDisplay
            title="主訴"
            content={requestSummary?.chiefComplaint ?? ''}
          />
        </div>
        <InfoDisplay
          title="指令内容"
          content={requestSummary?.telegramSummary ?? ''}
        />
        <InfoDisplay
          title="救急要請の概要"
          content={requestSummary?.requestSummary ?? ''}
        />
        <InfoDisplay
          title="現場到着時の状況等"
          content={requestSummary?.siteArrivalSituationSummary ?? ''}
        />
        <InfoDisplay
          title="自覚症状主訴及び初期評価"
          content={requestSummary?.firstEvaluation ?? ''}
        />
        <InfoDisplay
          title="服薬状況"
          content={
            <TagList
              tags={
                requestSummary?.medicationStatus?.map(
                  item => item.medicationName ?? ''
                ) ?? []
              }
            />
          }
        />
        <InfoDisplay
          title="服薬状況(詳細)"
          content={requestSummary?.medicationStatusComment ?? ''}
        />
        <InfoDisplay
          title="傷病経過"
          content={requestSummary?.clinicalCourse ?? ''}
        />
        <InfoDisplay
          title="既往歴等"
          content={<TagList tags={requestSummary?.medicalHistory ?? []} />}
        />
        <InfoDisplay
          title="既往歴等 自由記入欄"
          content={requestSummary?.medicalHistoryComment ?? ''}
        />
        <InfoDisplay
          title="かかりつけ医療機関"
          content={requestSummary?.primaryCare ?? ''}
        />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="アレルギーの有無"
            content={convertToPresenceAbsence(requestSummary.allergyPresence)}
          />
          <InfoDisplay
            title="アレルギー"
            content={requestSummary?.allergies ?? ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="最終食事時刻の特定状況"
            content={requestSummary?.isLastMeal}
          />
          <InfoDisplay
            title="最終食事日時"
            content={formatDateTime(requestSummary.lastMealAt)}
          />
          <InfoDisplay title="ADL" content={requestSummary?.adl ?? ''} />
        </div>
      </div>
    </BorderedContainer>
  );
};
